module.exports = __webpack_public_path__ + "img/email.747da0fe.png";